import { apiBaseUrl } from "./config";
import { api } from "./api/client";
import { liveStreamUrl } from "./live_stream_url";
import type { LiveCallEvent } from "./types";

export function connectLiveUpdates(
  onEvent: (event: LiveCallEvent) => void,
): () => void {
  let closed = false;
  let socket: WebSocket | null = null;
  let retryTimer: number | null = null;
  let retryAttempt = 0;

  async function connect() {
    if (closed) return;
    try {
      const { ticket } = await api.createLiveTicket();
      if (closed) return;
      socket = new WebSocket(liveStreamUrl(apiBaseUrl, ticket));
      socket.addEventListener("open", () => {
        retryAttempt = 0;
      });
      socket.addEventListener("message", (message) => {
        if (typeof message.data !== "string") return;
        try {
          const event = JSON.parse(message.data) as LiveCallEvent;
          if (
            event.type === "call-status" ||
            event.type === "conversation-update" ||
            event.type === "call-ended"
          ) {
            onEvent(event);
          }
        } catch {
          // Ignore malformed or keep-alive messages.
        }
      });
      socket.addEventListener("close", scheduleReconnect);
      socket.addEventListener("error", () => socket?.close());
    } catch {
      scheduleReconnect();
    }
  }

  function scheduleReconnect() {
    if (closed || retryTimer !== null) return;
    const delay = Math.min(15_000, 750 * 2 ** retryAttempt);
    retryAttempt += 1;
    retryTimer = window.setTimeout(() => {
      retryTimer = null;
      void connect();
    }, delay);
  }

  void connect();
  return () => {
    closed = true;
    if (retryTimer !== null) window.clearTimeout(retryTimer);
    socket?.close(1000, "page_closed");
  };
}

